export default "__VITE_ASSET__BJJqTT3p__"